import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import DateFilter from './DateFilter.vue'
import HospitalsFilter from './HospitalsFilter.vue'
import HoursFilter from './HoursFilter.vue'
import ScalesFilter from './ScalesFilter.vue'
import SectorFilter from './SectorFilter.vue'
import SpecialtyFilter from './SpecialtyFilter.vue'
import MoreFilters from './MoreFilters.vue'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { flags } = useFeatureFlags()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(DateFilter),
    _createVNode(HoursFilter),
    _createVNode(HospitalsFilter),
    _createVNode(ScalesFilter),
    (_unref(flags).enabledDashboardV2)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createVNode(SectorFilter),
          _createVNode(SpecialtyFilter)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(MoreFilters)
  ], 64))
}
}

})